import { create } from "zustand";

interface KycStoreState {
  acceptedTerms: boolean;
  acceptedRainTerms: boolean;
  isKycModalOpen: boolean;
  isSumsubProfileVerified: boolean;
  setAcceptedTerms: (accepted: boolean) => void;
  setAcceptedRainTerms: (accepted: boolean) => void;
  setKycModalOpen: (open: boolean) => void;
  setIsSumsubProfileVerified: (verified: boolean) => void;
}

export const useKycStore = create<KycStoreState>((set) => ({
  acceptedTerms: false,
  acceptedRainTerms: false,
  isKycModalOpen: false,
  isSumsubProfileVerified: false,
  setAcceptedTerms: (accepted) => set({ acceptedTerms: accepted }),
  setAcceptedRainTerms: (accepted) => set({ acceptedRainTerms: accepted }),
  setKycModalOpen: (open) => set({ isKycModalOpen: open }),
  setIsSumsubProfileVerified: (verified) =>
    set({ isSumsubProfileVerified: verified }),
}));
